export default "__VITE_ASSET__ef0157d7__"